import TKCustomElementFactory from '@tk/utilities/tk.custom.element.factory';

export default class TKCompareContent extends TKCustomElementFactory {
    itemsCounterElement: Element | undefined;

    constructor() {
        super();

        this.itemsCounterElement = this.querySelector('[data-compare-items-count]')
            || undefined;
    }

    connectedCallback(): void {
        this.registerAttributeChangeListener();
        this.onItemsCountChanged();
    }

    registerAttributeChangeListener() {
        if (!this.itemsCounterElement) throw new Error('Missing items count element');
        // Konfiguration des Observers
        const config = { attributes: true, attributeFilter: ['data-compare-items-count'] };

        // Erstellung des Mutation Observers mit der Ziel-Element und der Konfiguration
        const observer = new MutationObserver(this.onItemsCountChanged.bind(this));

        // Beginnen des Beobachtens des Ziel-Elements
        observer.observe(this.itemsCounterElement, config);
    }

    onItemsCountChanged() {
        const currentItemsCountString = this.itemsCounterElement?.getAttribute('data-compare-items-count');
        const currentItemsCount = parseInt(currentItemsCountString || '0', 10);

        const headerElement = this.querySelector('[data-tk-compare-header]');
        if (!headerElement) return;

        if (currentItemsCount === 0) {
            headerElement.classList.add('tk-compare__header--empty');
        } else {
            headerElement.classList.remove('tk-compare__header--empty');
        }
    }
}
